import React from "react";
import { LinkProps, withRouter, RouteComponentProps } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

class Anchor extends React.Component<LinkProps & RouteComponentProps<{}>>
{
    parseTo(to: string)
    {
        const { location } = this.props;
        try
        {
            if (to.startsWith("http"))
            {
                return new URL(to);
            }
            else if(to.startsWith("#"))
            {
                return new URL(location.pathname + location.search + to, globalThis.origin);
            }
            else
            {
                return new URL(to, globalThis.origin);
            }
        }
        catch (error)
        {
            return new URL("/", globalThis.origin);
        }
    }

    isInternal(to: string)
    {

        try
        {
            const toLocation = this.parseTo(to as string);
            if (toLocation)
            {
                if (/\.[a-zA-Z0-9]+$/.test(toLocation.pathname))
                {
                    // Treat all file extensions as external
                    return false;
                }

                const currentLocation = new URL(globalThis.origin);
                if (toLocation.host === currentLocation.host)
                {
                    return true;
                }
            }
        }
        catch (error)
        {
            return false;
        }

        // Server-side just treat all anchors as external
        return false;
    }

    render()
    {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { to, replace, innerRef, children, history, location, match, defaultValue, staticContext, component, ...rest } = this.props;

        const isInternal = this.isInternal(to as string);

        const parsedUrl = this.parseTo(to as string);

        if (isInternal && parsedUrl)
        {
            return (<HashLink {...rest} to={parsedUrl?.pathname + parsedUrl?.search + parsedUrl?.hash} replace={replace} innerRef={innerRef}>{children}</HashLink>);
        }
        else
        {
            return (<a {...rest} href={parsedUrl?.toString() as string} target="_blank" rel="noopener noreferrer">{children}</a>);
        }
    }
}

export default withRouter(Anchor);